<template>
    <div class="confirmar_identidad">
        <v-container class="text-xs-center">
            <v-dialog
                    v-model="dialog_bloqueo"
                    persistent
                    width="500"
            >
                <v-card class="justify-center">
                    <v-card-title
                            class="warning display-1 text--primary justify-center"
                            primary-title
                    >
                        {{$t('aviso')}}
                    </v-card-title>
                    <v-card-text class="text-xs-center">
                        <h2>{{$t('pagina_caduca')}}</h2>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn
                                color="primary"
                                large
                                to="/home"
                        >
                            <v-icon left>home</v-icon>
                            {{$t('inicio')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-layout calign-center justify-center fill-height>
                <v-card width="300">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{$t('authorize_access')}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text class="justify-center">
                        <v-layout row wrap>
                            <v-flex xs12>
                              <p v-if="info.length > 0">
                               {{$t('the_person')}} <strong>{{info[0].nombre}}</strong> {{$t('has_arrived')}}
                              </p>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap  v-if="info.length > 0">
                            <v-flex xs12 v-if="info[0].authorized === false">
                                <v-btn
                                        color="primary"
                                        :loading="loading"
                                        @click="notifyAccessNoCode()"
                                >
                                    {{$t('authorize')}}
                                </v-btn>
                            </v-flex>
                            <v-flex xs12 v-else>
                                <v-alert
                                    :value="true"
                                    type="success">
                                    {{$t('authorized_access')}}
                                </v-alert>
                                <v-btn
                                        color="primary"
                                        block
                                        to="/home"
                                >
                                    <v-icon left>home</v-icon>
                                    {{$t('inicio')}}
                                </v-btn>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex class="edge pl-3 pr-3 pt-3 pb-3">
                                <v-img
                                        v-if="info.length > 0"
                                        readonly
                                        outlined
                                        :src="info[0].url_foto"
                                ></v-img>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import store from '@/store'
    import { mapGetters } from 'vuex'

    export default {
        name: "authorized_access_no_code",
        data () {
            return {
                confirmar: null,
                errores: [],
                info: '',
                loading: false,
                dialog_bloqueo: false
            }
        },
        created: async function(){
            // console.log('PATHHHHH = ', localStorage.getItem('path_confirmed'))
            //Obtener los Datos del Invitado
            await this.get_info_invitation_by_user()
        },
        computed: {
            ...mapGetters(['getProfile'])
        },
        methods:{
            notifyAccessNoCode () {
                this.loading = true
                const config = {
                    method: 'post',
                    url: 'https://empresa-service.intrare.app/grant_access_no_code_push_notification/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                        'nombre': this.info[0].nombre,
                        'id': this.$route.params['idBitacora']
                    }
                }
                axios(config)
                    .then(ok => {
                        this.loading = false
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', this.$t('msg_acceso_exito'))
                        setTimeout(this.clear, 3000);
                        console.log('Notificado!!!')
                    })
                    .catch(error => {
                        this.loading = false
                        console.log(error)
                    })
                    .finally(() => (this.loading = false))
            },
            get_info_invitation_by_user: async function () {
                console.log('GET INFO')
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/bitacora_authorized/' + this.$route.params['idBitacora'],
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                };
                axios(config)
                    .then(ok => {
                        this.info = ok.data
                        if(ok.data.length === 0){
                            this.dialog_bloqueo = true
                            console.log('Página Expirada .... overlay = ', this.dialog_bloqueo)
                        }
                    })
                    .catch(error => {
                        if(error.response && error.response.status == 400
                            && typeof error.response.data == "object"
                            && error.response.data)
                            this.errores = error.response.data
                    })
                    .finally(() => (this.loading = false))
            },
            clear(){
                this.$store.commit('snackbar_change_color', 'success')
                this.$store.commit('snackbar_activate_false')
                location.reload()
            }
        }
    }
</script>

<style scoped>
    .error {
        font-weight: bold;
        color: red;
    }
    .edge {
        border-radius: 8px;
        border-color: #002b48 #002b48 #002b48 #002b48;
        border-width: 3px 3px 3px 3px;
        border-style: solid solid solid solid;
    }
</style>
